#import "./UserDefaultFields.graphql"

query UserDefaults {
  userDefaults {
    nodes {
      ...UserDefaultFields
      lookupAccounts {
        lookupAccount
        lookupName
      }
      lookupAccountId
      referenceCode6
      referenceCode7
      _homeCountryId
    }
  }
}
